module.exports = __webpack_public_path__ + "img/icons BFr_21.0e3fe48f.png";